import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';
import { View } from '@zhike/ti-ui';
import styles from './styles';


export default class AccuracyTable extends React.Component {
  static propTypes = {
    labelsArr: PropTypes.array,
  };

  static defaultProps = {
    labelsArr: [],
  };
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  render() {
    const { labelsArr } = this.props;
    return (
      <View className={styles.container}>
        {
          labelsArr && labelsArr.map((label, index) => {
            const { accuracy, name } = label;
            const num = Math.ceil(accuracy / 0.2);
            const newArr = [];
            for (let i = 1; i <= 5; i += 1) {
              if (i <= num) {
                newArr.push('blue');
              } else {
                newArr.push('gray');
              }
            }
            return (
              <View className={styles.labelContainer} key={index}>
                <View className={styles.labelName}>{name}</View>
                <View className={styles.accuracy} key={index}>
                  {
                  newArr.map((item, index) => {
                    if (item === 'blue') {
                      return (
                        <View
                          key={index}
                          className={[styles.rectangle, styles[`grade${index + 1}`]]}
                        />
                      );
                    }
                    return (
                      <View
                        key={index}
                        className={[styles.rectangle, styles.gray]}
                      />
                    );
                  })
                  }
                </View>
                <View className={styles.number}>{ `${Math.round(accuracy * 100)}%` }</View>
              </View>
            );
          })
        }
        <View className={styles.grade}>
          <span className={css(styles.rank)}>很弱</span>
          <span className={css(styles.rank)}>较弱</span>
          <span className={css(styles.rank)}>弱</span>
          <span className={css(styles.rank)}>一般</span>
          <span className={css(styles.rank)}>良好</span>
        </View>
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/report/evaluation_report/common/accuracy_table/index.js